import { ConvertCanvasToFile } from "./types";

export const convertCanvasToFile: ConvertCanvasToFile = ({
  canvas,
  fileName = "image.png",
  mimeType = "image/png",
  quality = 1.0, // Quality parameter (1.0 = best)
}) => {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error("Canvas conversion failed"));
          return;
        }
        const file = new File([blob], fileName, { type: mimeType });
        resolve(file);
      },
      mimeType,
      quality,
    );
  });
};
